import { reactive } from 'vue'
import { apiFetch } from './api'

export interface AppNotification {
  id: string
  type: string
  title: string
  message: string
  relatedType: string
  relatedId: string
  dueDate: string
  readAt: string
  createdAt: string
}

function asRecord(value: unknown): Record<string, unknown> {
  return value && typeof value === 'object' ? (value as Record<string, unknown>) : {}
}

function mapNotification(value: unknown): AppNotification {
  const row = asRecord(value)
  return {
    id: String(row.id || ''),
    type: String(row.type || 'info'),
    title: String(row.title || 'Notificacao'),
    message: String(row.message || ''),
    relatedType: String(row.relatedType || ''),
    relatedId: String(row.relatedId || ''),
    dueDate: String(row.dueDate || ''),
    readAt: String(row.readAt || ''),
    createdAt: String(row.createdAt || '')
  }
}

const state = reactive({
  items: [] as AppNotification[],
  loading: false
})

export const notificationsStore = {
  state,
  all() {
    return state.items
  },
  unreadCount() {
    return state.items.filter((item) => !item.readAt).length
  },
  async refresh() {
    state.loading = true
    try {
      const rows = await apiFetch<unknown[]>('/notifications')
      state.items = rows.map(mapNotification)
      return state.items
    } finally {
      state.loading = false
    }
  },
  async markRead(id: string) {
    await apiFetch<{ ok: boolean }>(`/notifications/${encodeURIComponent(id)}/read`, {
      method: 'POST',
      body: JSON.stringify({})
    })
    await this.refresh()
  },
  async markManyRead(ids: string[]) {
    if (ids.length === 0) return
    await apiFetch<{ ok: boolean }>('/notifications/bulk-read', {
      method: 'POST',
      body: JSON.stringify({ ids })
    })
    await this.refresh()
  },
  async deleteMany(ids: string[]) {
    if (ids.length === 0) return
    await apiFetch<{ ok: boolean }>('/notifications/bulk-delete', {
      method: 'POST',
      body: JSON.stringify({ ids })
    })
    await this.refresh()
  }
}
